import {z} from "zod";
import {UiFieldBaseSchema} from "./UiField";

export const DateTimePickerFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('DateTimePickerField'),
});

export type DateTimePickerField = z.infer<typeof DateTimePickerFieldSchema>;